import { enumToString } from 'clerk_common/enums';

const EQUIPMENT_CONTROL_MODE_PATTERN = /\((Continuous|Start\/Stop)\)$/i;

export function parseEquipmentControlMode(
  description?: string
): string | undefined {
  return description?.match(EQUIPMENT_CONTROL_MODE_PATTERN)?.[1];
}

export function formatMovementEquipmentTypeLabel(equipment: {
  equipmentType?: string;
  description?: string;
}): string {
  const description = equipment.description?.trim();
  if (description) {
    const withoutControlMode = description
      .replace(EQUIPMENT_CONTROL_MODE_PATTERN, '')
      .trim();
    if (withoutControlMode) return withoutControlMode;
  }
  return enumToString(equipment.equipmentType || 'Not specified');
}
